import React, { Fragment } from 'react'
import { Modal, Button } from 'react-bootstrap'

const DuplicateMetadataModal = (props) => {
  const { show, name, type, values, isExactDuplicate, typeOrValue, client, projectOrProposal } = props

  let titleText, bodyText, confirmSaveText, clientName

  if (client) {
    clientName = ` for ${client.name} ${client.short_code}`
  } else {
    clientName = ''
  }

  if (typeOrValue === 'type' && isExactDuplicate) {
    titleText = `${projectOrProposal} Metadata Already Exists`
    bodyText = `A ${projectOrProposal.toLowerCase()} metadata with that exact name already exists in the database${clientName}.`
    confirmSaveText = `${projectOrProposal} Metadata names must be unique.`
  } else if (typeOrValue === 'type') {
    titleText = `Similar ${projectOrProposal} Metadata Already Exists - Proceed Anyway?`
    bodyText = `A ${projectOrProposal.toLowerCase()} metadata with a similar name already exists in the database${clientName}.`
    confirmSaveText = "Are you sure you want to save anyway?"
  } else if (typeOrValue === 'value' && isExactDuplicate) {
    titleText = `${projectOrProposal} Metadata Value Already Exists`
    bodyText = `A ${projectOrProposal.toLowerCase()} metadata value with that exact name already exists in the database${clientName}.`
    confirmSaveText = `${projectOrProposal} Metadata values must be unique.`
  } else if (typeOrValue === 'value') {
    titleText = `Similar ${projectOrProposal} Metadata Value Already Exists - Proceed Anyway?`
    bodyText = `A ${projectOrProposal.toLowerCase()} metadata value with a similar name already exists in the database${clientName}.`
    confirmSaveText = "Are you sure you want to save anyway?"
  }

  return (
    <Modal show={show}>
      <Modal.Header>
        <Modal.Title>
          {titleText}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <p>
          {bodyText}
        </p>

        <p>
          Name: <strong>{name}</strong>
        </p>

        {type ?
          <p>
            Type: <strong>{type}</strong>
          </p>
          :
          null
        }

        {isExactDuplicate ?
          null
          :
          <Fragment>
            {values ?
              <Fragment>
                {values.length === 0 ?
                  <p>
                    There are no values associated with this metadata type
                  </p>
                  :
                  <Fragment>
                    <p>
                      Associated Values:
                    </p>
                    <ul>
                      {values.map(metadataValue => {
                          return (
                            <li key={metadataValue.id}>
                              {metadataValue.option}
                            </li>
                          )
                        })}
                    </ul>
                  </Fragment>
                }
              </Fragment>
              :
              null
            }
          </Fragment>
        }

        <p>
          {confirmSaveText}
        </p>

      </Modal.Body>

      {isExactDuplicate ?
        <Modal.Footer>
          <Button onClick={props.handleCancelSubmit}>
            OK
          </Button>
        </Modal.Footer>
        :
        <Modal.Footer>
          <Button onClick={props.handleCancelSubmit}>
            Cancel
          </Button>
          <Button onClick={props.handleSubmit}>
            Save Anyway
          </Button>
        </Modal.Footer>
      }

    </Modal>
  )
}

export default DuplicateMetadataModal



// WEBPACK FOOTER //
// ./src/routes/manager/components/DuplicateMetadataModal.js